<template>
    <div class="home">
        <div class="nav_list">
            <div class="logo-left">
              <img src="../assets/logo.png" alt="">
            </div>
            <div class="nav_right">
                <div :style="nvaIndex==index?'color:#efb336':''" class="tilte" v-for="(item,index) in gemelist" :key="item.name" @click="daohang(index)">
                    <img v-show="nvaIndex!==index" src="../assets/b_ico.png" alt="">
                    <img v-show="nvaIndex==index" src="../assets/h_ico.png" alt="">
                    <span v-show="$store.state.EnZh">{{item.en_name}}</span>
                    <span v-show="!$store.state.EnZh">{{item.zh_name}}</span>
                    <img v-show="nvaIndex!==index" src="../assets/b_ico.png" alt="">
                    <img v-show="nvaIndex==index" src="../assets/h_ico.png" alt="">
                </div>
                <img v-show="$store.state.EnZh" src="../assets/famyi_bai.png" class="xuanzekuang" alt="" @click="changeEn()">
                <img v-show="!$store.state.EnZh" src="../assets/wen_bai.png" style="width: 32px;" alt="" class="xuanzekuang" @click="changeEn()">
            </div>
            
        </div>
        <div class="swiper-container lunbo">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <div class="shouYI">
                        <img class="beijingtu" src="../assets/bj_2000x1000.jpg" alt="">
                        <div class="renwu">
                            <div :class="nvaIndex==0?'jihe_renwu animate__animated animate__zoomIn':'jihe_renwu'">
                                <img src="../assets/yaojishi.png" alt="">
                                <img src="../assets/yinchangzhe.png" alt="">
                                <img src="../assets/jujijingying.png" alt="">
                            </div>
                            <!-- <img class="log_tt animate__animated animate__fadeInUp" src="../assets/logo.png" alt=""> -->
                        </div>
                        <!-- 下载 -->
                        <div :class="nvaIndex==0?'Touming_xiazai animate__animated animate__zoomInUp':'Touming_xiazai'">
                            <!-- <img class="erwei_ma_xiazai" src="../assets/erweima.png" alt=""> -->
                            <div class="heibai_xd">
                                <a href="https://apps.apple.com/us/app/brave-defense/id6737433451" target="_blank" rel="noopener">
                                    <img src="../assets/anzhuo_ji.png" alt="">
                                </a>
                                <a href="https://play.google.com/store/apps/details?id=com.yinweiyouli.guardian&pli=1" target="_blank" rel="noopener">
                                    <img src="../assets/pingguoji.png" alt="">
                                </a>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="renwu_jieshao"> 
                        <img class="xuanya_img" src="../assets/heroes_terrains_clean_bg.png" alt="">
                        <div class="BiaoTi_img" style="margin-top:6%;">{{$t('feature.tilteName')}}</div>
                        <div class="ts-div">
                            <div :class="ys>0?'ts-div-item animate__animated animate__backInRight':'opa'">
                                <img src="../assets/Build.png" alt="">
                                <p class="jianjie_tu">Thousands of genres</p>
                            </div>

                            <div :class="ys>1?'ts-div-item animate__animated animate__backInRight':'opa'">
                                <img src="../assets/传统塔防.png" alt="">
                                <p class="jianjie_tu">conquer the enemy</p>
                            </div>
                            <div :class="ys>2?'ts-div-item animate__animated animate__backInRight':'opa'">
                                <img src="../assets/雷神之锤.png" alt="">
                                <p class="jianjie_tu">Random Secrt Realm</p>
                            </div>
                            <div :class="ys>3?'ts-div-item animate__animated animate__backInRight':'opa'">
                                <img src="../assets/猎杀者.png" alt="">
                                <p class="jianjie_tu">Ghostface Law Enforcer</p>
                            </div>
                            <div :class="ys>4?'ts-div-item animate__animated animate__backInRight':'opa'">
                                <img src="../assets/绚丽画面.png" alt="">
                                <p class="jianjie_tu">Steampunk</p>
                            </div>
                        </div>
                        <Foorm style="width: 100vw; height: 160px;"/>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>     
<script>
    import {Swiper,Mousewheel,Autoplay,EffectFade,EffectCube} from 'swiper';
    import Foorm from '@/components/fooret.vue';
    export default{
        components: {
            Foorm,
        },
        data(){
            return{
                ImgRul:[{img:require("../assets/chang1.png"),text:"Thousands of genres"},
                        {img:require("../assets/chang2.png"),text:"conquer the enemy"},
                        {img:require("../assets/chang3.png"),text:"Random Secrt Realm"},
                        {img:require("../assets/chang4.png"),text:"Ghostface Law Enforcer"},
                        {img:require("../assets/chang5.png"),text:"Steampunk"}
                    ],

                jiantou:false,
                mySwiper:'',
                language:'中文',
                gemelist:[
                {zh_name:'游戏下载',en_name:'Download'},
                {zh_name:'游戏特色',en_name:'Feature'}
                ],
                nvaIndex:0,
                ys:0,//延时器
            }   
        },
        mounted(){
            Swiper.use([Mousewheel,Autoplay,EffectFade,EffectCube])
           this.mySwiper =  new Swiper('.lunbo', {
                    direction: 'vertical',//竖向
                    mousewheel:true,//鼠标控制上下
                    resistanceRatio:0,//取消回弹效果
                    simulateTouch:false,//禁用鼠标拖拽
                    speed: 1000,
                    on: {//触发
                        slideChange:(Swiper)=>{
                        // console.log(Swiper.activeIndex);
                        this.nvaIndex = Swiper.activeIndex;
                            if(this.nvaIndex==1){
                                if(this.ys>=5){
                                    this.ys=0;
                                }
                                const ysq = setInterval(() => {
                                    this.ys = this.ys+1
                                    if(this.ys>=5){
                                        
                                        console.log(this.ys)
                                        clearInterval(ysq);
                                    }
                                }, 200);
                            }
                        }
                    },
                    
            });
            // document.getElementById('diao').addEventListener('click', function() {
            //     this.mySwiper.slideTo(0, 1); // 第二个参数是滑动速度，0表示立即跳转
            // });
            new Swiper('.zi_nei', {
                    loop:true,
                    autoplay:true,
            });
        },
        methods:{
            scrollToSection(sectionId) {
                const element = document.getElementById(sectionId);
                if (element) {
                window.scrollTo({
                    top: element.offsetTop,
                    behavior: 'smooth' // 平滑滚动效果
                });
                }
            },
             //切换语言
            changeEn(){
            if(this.$i18n.locale=='zh'){
                this.$i18n.locale='en';
                this.$store.state.EnZh= true;
                console.log(this.$store.state.EnZh)
                localStorage.setItem('lang', 'en');
            }else{
                this.$i18n.locale='zh';
                this.$store.state.EnZh= false;
                console.log(this.$store.state.EnZh)
                localStorage.setItem('lang', 'zh');
            }
            },
            // 跳转游戏官网
            qiehuan(command) {
                this.language = command
            },
            //导航
            daohang(index){
            this.nvaIndex = index;
            switch(index){
                case 0:
                this.mySwiper.slideTo(index, 1000);
                break;
                case 1:
                this.mySwiper.slideTo(index, 1000);
                break;
                case 2:
                
                break;
                case 3:
                
                break;
            }
            },
        }
    }
</script>
<style  lang="scss">
.el-carousel__container{
    height: 100%;
    overflow: hidden;
}
.el-carousel__indicators--outside{
    position: absolute;
    bottom: 0;
    left: 35%;
}


.el-carousel__button{
    height: 5px;
    border-radius: 5px;
}
.home{
    width: 100%;
    overflow: hidden;
//导航
    .nav_list{
          width: 100%;
          height: 70px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: rgb(0, 0, 0);
          z-index: 100;
          position: fixed;
          .logo-left{
            width: 110px;
            margin-left: 6%;
            img{
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .nav_right{
            margin-right: 2%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .tilte{
              width: 135px;
              height: 40px;
              display: flex;
              align-items: center;
              color: #fff;
              font-size: 16px;
              margin-left: 40px;
              justify-content: space-around;
              
              img{
                width: 20px;
                margin-top: 6px;  
              }
            }
          }
          .xuanzekuang{
            width: 35px;
            margin-left: 25px;
            text-align: center;
            color: #fff;
            font-size: 13px;
            .xiala{
              font-size: 14px;
              color: #fff;
             
            }
          }
          
        }

.lunbo{
    width: 100%;
    height: 100vh;
    background-color: #5a5a5a;
    // 第一屏
    .shouYI{
      width: 100%;
      height: 100vh;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: baseline;
      background-color: black;
      z-index: 5;
      .beijingtu{
        width: 100%;
        height: 100%;
      }
      .Touming_xiazai{
        // width: 630px;
        
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 10px;
        position: absolute;
        z-index: 80;
        bottom: 12%;
        display: flex;  
        align-items: center;
        padding: 6px 6px;
        justify-content: space-around;
        .erwei_ma_xiazai{
            width: 150px;
            height: 150px;
            object-fit: contain;
            padding: 6px 8px;
            background-color: #fff;
            border-radius: 10px;
        }
        .heibai_xd{
            padding: 5px 20px;
            height: 150px;
            background-color: #fff;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            margin-left: 10px;
            img{
                height: 55px;
               
            }
            
        }
      }
      .renwu{
        width: 75%;
        height:90%;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        margin-top: 60px;
        .jihe_renwu{
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            img:nth-child(1){
                width: 40%;
                object-fit: contain;
                float: left;
                position: absolute;
                top: 35%;
                left: 0;
                z-index: 9;
            }
            img:nth-child(2){
                width:43%;
                object-fit: contain;
                position: absolute;
                top: 3%;
                left: 22.5%;
                z-index: 10;
                float: left;
            }
            img:nth-child(3){
                width: 41%;
                object-fit: contain;
                position: absolute;
                top: 29%;
                right: 0;
                z-index: 9;
            }
        }
        .log_tt{
            width: 47%;
            object-fit: contain;
            position: absolute;
            bottom: 2%;
            opacity: 1;
            z-index: 25;
        }
      }
      
    } 
    //特色
    .renwu_jieshao{
        width: 100%;
        height: 100vh;
        overflow: hidden;
        background-image: url("../assets/bg_terrenos_footer.jpg");
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        padding-bottom:200px;
        // 悬崖
        .xuanya_img{
            width: 100%;
            position: absolute;
            top: -50px;
            z-index: 1;
        }
        // 标题
        .BiaoTi_img{
            color: hsl(0, 0%, 100%);
            margin-top: 10%;
            letter-spacing: 5px;
            font-size: 60px;
            font-family: Tafang;
            position: relative;
            z-index: 5;
            text-shadow: 1px 1px 0px rgb(110, 110, 110),
            2px 2px 0px rgb(110, 110, 110),
            4px 4px 0px rgb(110, 110, 110),
            6px 6px 0px rgb(110, 110, 110);
        }
        // 特色介绍
        .ts-div{
            width: 70%;
            height: 60%;
            // background-color: #5a5a5a;
            // overflow: hidden;
            display: flex;
            z-index: 5;
            align-items: center;    
            justify-content: space-between;
            flex-wrap: wrap;
            margin-top: 2%;
            
            .ts-div-item{
                width: 17%;
                border-radius: 10px;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                visibility: block;
                transition: 0.3s;
                img{
                    padding: 5px 5px;
                    border: solid 2px rgb(255, 255, 255);
                    width: 100%;
                    border-radius: 10px;
                    transition: 0.3s;
                }
                .jianjie_tu{
                    font-size: 19px;
                    color: rgb(255, 255, 255);
                    font-weight: bold;
                    margin-top: 15px;
                    text-decoration: underline;
                }
            }   
            .ts-div-item:hover img{
                    transition: 0.2s;
                    padding: 5px 5px;
                    border: solid 2px rgb(255, 179, 17);
                    width: 104%;
                    border-radius: 10px;
            }
            .ts-div-item:hover .jianjie_tu{
                color: rgb(234, 215, 0);
            }
            .opa{
                visibility: hidden;
                transition: 0.3s;
            }
        }
        // 更新前瞻
        .qianzhan{
            width: 70%;
            height: 500px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 30px;
            .zuoLun_el{
                width: 47%;
                height: 70%;
                overflow: hidden;
                border: solid 3px #fff;
                border-radius: 10px;
                .dati_lunbo{
                    width: 100%;
                    height: 100%;
                }
            }
            .zuoLun_el:hover{
                border: solid 3px hsl(33, 100%, 66%);
            }
            .youzi_text{
                width: 47%;
                height: 64%;
                overflow: hidden;
                border: solid 3px #ffffff;
                border-radius: 10px;
                background-color: rgb(0, 111, 117);
                padding: 15px 15px;
                .tile_text{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-size: 25px;
                    color: rgb(255, 255, 255);
                    font-family: Tafang;
                    img{
                        width: 25px;
                        
                    }
                }
                .tile_text:hover{
                    color: hsl(33, 100%, 61%);
                }
                // .xinxi_wenben::-webkit-scrollbar{
                //     display:none;/*隐藏滚动条*/
                // } 
                .xinxi_wenben{
                    padding: 5px 15px;
                    height:82%;
                    background-color: #fff;
                    border-radius: 10px;
                    margin-top: 15px;
                    overflow-y: auto;
                    
                    .pp_text_wenzi{
                        width: 100%;
                        border-bottom: solid 1px #c3c3c3;
                        line-height: 50px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        span:nth-child(1){
                            width: 80%;
                            overflow: hidden;
                            /* 不让文本换行 除非遇到br标签 */
                            white-space:nowrap;
                            /* 溢出文字用...代替 */
                            text-overflow: ellipsis;
                            font-size: 16px;
                        }
                        span:nth-child(2){
                            overflow: hidden;
                            /* 不让文本换行 除非遇到br标签 */
                            white-space:nowrap;
                            /* 溢出文字用...代替 */
                            text-overflow: ellipsis;
                            font-size: 14px;
                            color: #5a5a5a;
                        }
                    }
                }
                /* 定义滚动条样式 */
                .xinxi_wenben::-webkit-scrollbar {
                        width: 6px;
                        height: 6px;
                        background: rgba(211, 211, 211, 0.7);
                }
                /*定义滚动条轨道*/
                .xinxi_wenben::-webkit-scrollbar-track {
                        box-shadow: inset 0 0 0px rgba(240, 240, 240, .5);
                        border-radius: 10px;
                        background: rgba(255, 255, 255, 0.7);
                }
                /*定义滑块*/
                .xinxi_wenben::-webkit-scrollbar-thumb {
                        border-radius: 10px;
                        box-shadow: inset 0 0 0px rgba(118, 118, 118, 0.5);
                        background-color: rgba(118, 118, 118, 0.5);
                }
            }
           
        }
    }
    
}
}
@font-face{
  font-family: Tafang;
  src:url('../assets/789.ttf');
}
    
</style>